import React from "react";
import * as styles from "./CaseTestimonials.module.scss";
import { TypographyV2 } from "@components";
import classNames from "classnames";

import {
	JiahL,
	AngieR,
	ArnoC,
	BhavyaV,
	LydiaM,
	MarcoT,
	SimonK,
} from "@assets/caseStudy/index";

interface TestimonialProps {
	name: string;
	comment: string;
	businessType: string;
	image: React.ReactNode;
}

const testimonials: TestimonialProps[][] = [
	[
		{
			name: "Jiah L.",
			comment:
				"UI of Genemod platform is really easy to use and integrating our previous research data into Genemod system is very convenient.",
			businessType: "Small Business (50 or fewer emp.)",
			image: <JiahL />,
		},
		{
			name: "Lydia M.",
			comment:
				"We used excel spreadsheets and google docs for inventory management and report generation, but Genemod helped to accelerate our research through easier management of our inventory and lab data.",
			businessType: "Enterprise (>1000 emp.)",
			image: <LydiaM />,
		},
		{
			name: "Anton N.",
			comment:
				"We have been using Genemod for a short period of time, but are already finding the interface and ease of use to be much better than our current inventory software.",
			businessType: "Small Business (50 or fewer emp.)",
			image: <JiahL />,
		},
	],
	[
		{
			name: "Angie R.",
			comment:
				"I use Genemod daily, it is highly accessible and intuitive. The inventory tools allow for easy organization and integration with ordering and reports is valuable.",
			businessType: "Small Business (50 or fewer emp.)",
			image: <AngieR />,
		},
		{
			name: "Bhavya V.",
			comment:
				"Genemod is a formidable ally for researchers seeking to elevate their laboratory management practices. As a researcher who values efficiency and precision, I wholeheartedly recommend Genemod to colleagues and fellow scientists aiming to enhance their research capabilities.",
			businessType: "Enterprise (>1000 emp.)",
			image: <BhavyaV />,
		},
		{
			name: "Simon K.",
			comment:
				"Great layout, easy to maneuver, organizational efficiency.",
			businessType: "Small Business (50 or fewer emp.)",
			image: <SimonK />,
		},
	],
	[
		{
			name: "Arno C.",
			comment:
				"Genemod has a very clean and intuitive interface. This allows everyone in the team to easily collaborate with each other on the same platform, and at the same time keep an overview of what has been changed by different users.",
			businessType: "Enterprise (>1000 emp.)",
			image: <ArnoC />,
		},
		{
			name: "Keith K.",
			comment:
				"Genemod offers a great LIMS software for research laboratories. Our research team is using Genemod almost every day for our inventory management.",
			businessType: "Enterprise (>1000 emp.)",
			image: <JiahL />,
		},
		{
			name: "Marco T.",
			comment:
				"I love the visual representation of cold storage space, down to shelves and racks. The dry storage space and lab space design is a wonderful addition to the equation.",
			businessType: "Small Business (50 or fewer emp.)",
			image: <MarcoT />,
		},
	],
];

const CaseTestimonials = () => {
	return (
		<div className={styles.wrapper}>
			<TypographyV2
				variant="HEADING_3"
				color="brand-500"
				className={styles.title}
			>
				See why our customers love us.
			</TypographyV2>
			<section className={styles.overall}>
				{testimonials.map((group, groupIndex) => (
					<main
						key={groupIndex}
						className={classNames(styles.testimonials, {
							[styles.firstGroup]: groupIndex === 0,
							[styles.secondGroup]: groupIndex === 1,
							[styles.mobileLast]: groupIndex === 1,
							[styles.last]: groupIndex === 2,
						})}
					>
						{group.map((testimonial, index) => (
							<TestimonialCard
								key={index}
								testimonial={testimonial}
							/>
						))}
					</main>
				))}
			</section>
		</div>
	);
};

export default CaseTestimonials;

interface TestimonialCardProps {
	testimonial: TestimonialProps;
}

const TestimonialCard = ({ testimonial }: TestimonialCardProps) => {
	return (
		<div className={styles.container}>
			<section className={styles.head}>
				<div className={styles.image}>{testimonial.image}</div>
				<div className={styles.wrap}>
					<TypographyV2
						variant="BODY_TEXT_LARGE"
						color="brand-500"
						className={styles.name}
					>
						{testimonial.name}
					</TypographyV2>
					<TypographyV2
						variant="BODY_TEXT_SMALL"
						color="text-tertiary"
						className={styles.businessType}
					>
						{testimonial.businessType}
					</TypographyV2>
				</div>
			</section>
			<TypographyV2
				color="text-secondary"
				variant="BODY_TEXT_MEDIUM"
				className={styles.comment}
			>
				{testimonial.comment}
			</TypographyV2>
		</div>
	);
};
